export default [
  {
    path: '/ryr-registros/',
    name: 'registrosryr',
    component: () => import('@/views/ryr/registros_ryr.vue'),
    meta: {
      pageTitle: 'Listar Registros R & R',
      breadcrumb: [
        {
          text: 'Registros R & R',
        },
        {
          text: 'Listar Registros R & R',
          active: true,
        },
      ],
      resource: 'Registros R y R',
      action: 'menu',
    },
  },
  {
    path: '/ryr/Tareo_diario',
    name: 'tareodiariore',
    component: () => import('@/views/reclutamiento/reclutado/reclutamiento.vue'),
    meta: {
      pageTitle: 'Listar Tareo Diario',
      breadcrumb: [
        {
          text: 'Tareo Diario',
        },
        {
          text: 'Listar Tareo Diario',
          active: true,
        },
      ],
      resource: 'Tareo Diario Re',
      action: 'menu',
    },
  },
  {
    path: '/ryr/Lider_zona',
    name: 'liderzonare',
    component: () => import('@/views/reclutamiento/reclutado/liderZona.vue'),
    meta: {
      pageTitle: 'Listar Líder Zona',
      breadcrumb: [
        {
          text: 'Líder Zona',
        },
        {
          text: 'Listar Lider Zona',
          active: true,
        },
      ],
      resource: 'Lider Zona Re',
      action: 'menu',
    },
  },
]
